module.exports = __webpack_public_path__ + "media/investors/follow-case-51ee66b8.png";